module.exports = __webpack_public_path__ + "static/media/sbLogo.e00f9ea3.png";